import React, { useState, useEffect, useContext } from 'react'
import { useStateWithCallbackLazy } from 'use-state-with-callback'
import { Modal, Row, Col, Pagination, Form, Button, Spinner } from 'react-bootstrap'
import { LanguageContext } from '../Language/LanguageContext'
import { listGallery, viewAlbum, uploadToAlbum } from '../Network/Gallery'
import { baseURL } from "../Network/Config"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faImages, faArrowLeft, faCheck } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import "./ImageModal.css"

function ImageModal(props){
    const [isLoading, setLoading] = useState(false)
    const multipleSelect = props.multipleSelect || false
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.news
    const [galleryList, setGalleryList] = useState([])
    const [page, setPage] = useStateWithCallbackLazy(1)
    const size = 12
    const [lastLength, setLastLength] = useState(0);
    const [selectedAlbum, setSelectedAlbum] = useState(null);
    const [selectedTitle, setSelectedTitle] = useState("");
    const [selectedImage, setSelectedImage] = useState([]);
    const [choseImage, setChoseImage] = useState({imageId: null, path: null});
    const [choseImages, setChoseImages] = useState([])
    const [toUpload, setToUpload] = useState(null);

    const fetchData = (page, size, loadNew) =>{
        setLoading(true)
        listGallery(page, size,
            (data)=>{
                if(loadNew){
                    setGalleryList(data)
                }else{
                    data.forEach((item)=>{
                        setGalleryList(oldData => [...oldData, item])
                    })
                }
                setLastLength(data.length)
                setLoading(false)
            },
            (error)=>{
                setLoading(false)
            })
    }

    const fetchAlbum = (albumId) =>{
        setLoading(true)
        viewAlbum(albumId,
            (data)=>{
                setSelectedTitle(data.albumName)
                setSelectedImage(data.images)
                setLoading(false)
            },
            (error)=>{
                setLoading(false)
            })
    }

    const nextPage = () =>{
        setPage(page + 1, (current)=>{
            fetchData(current, size, true)
        });
    }

    const prevPage = () =>{
        setPage(page - 1, (current)=>{
            fetchData(current, size, true)
        });
    }

    const loadMore = () =>{
        setPage(page + 1, (current)=>{
            fetchData(current, size, false)
        });
    }

    const onScroll = (event) =>{
        const target = event.target
        if(target.scrollHeight - target.scrollTop === target.clientHeight){
            if(lastLength >= size){
                loadMore()
            }
        }
    }

    const selectImage = (id, path) =>{
        if(multipleSelect){
            if(!choseImages.some(e=>e.imageId === id)){
                setChoseImages(oldArr => [...oldArr, {imageId: id, path: path}])
            }else{
                setChoseImages(choseImages.filter(item=>item.imageId !== id))
            }
        }else{
            setChoseImage({imageId: id, path: path})
        }
    }

    const uploadImage = () =>{
        setLoading(true)
        uploadToAlbum(selectedAlbum, toUpload,
            ()=>{
                setLoading(false)
                fetchAlbum(selectedAlbum)
            },(error)=>{
                setLoading(false)
            })
    }

    const submitImage = () =>{
        if(multipleSelect){
            props.onCallbackImage(choseImages)
        }
        else{
            props.onCallbackImage(choseImage)
        }
        clearData()
    }

    const checkDisabledButton = () =>{
        if(multipleSelect){
            return choseImages.length <= 0 ? true:false
        }else{
            return !choseImage.imageId ? true:false
        }
    }

    const clearData = () =>{
        setSelectedAlbum(null)
        setSelectedTitle("")
        setSelectedImage([])
        setChoseImage({imageId: null, path: null})
        setChoseImages([])
    }

    useEffect(()=>{
        fetchData(page, size, true)
    },[])

    return(
        <Modal 
        show={props.show} 
        onHide={props.onHide}
        size="lg"
        >
            <Modal.Header className="modal-header" closeButton>
                <div>
                    {lang.select_image}
                </div>
                
            </Modal.Header>
            <Modal.Body>
                { selectedAlbum === null ?
                <div>
                    <div className="desc">
                        <div>
                            <div>{lang.please_select_image}</div>
                            <div>
                                {lang.if_upload_more}&nbsp;
                                <Link to="/gallery">{lang.go_gallery}</Link>
                            </div>
                        </div>
                        { isLoading ?
                        <div>
                            <Spinner
                            variant="primary"
                            animation="border"
                            />
                        </div>
                        : null
                        }
                    </div>
                    <div className="row-container" onScroll={onScroll}>
                        <Row>
                            { galleryList.map((item, key)=>
                            <Col key={key} sm={6} lg={4}>
                                <AlbumItem 
                                title={item.albumName}
                                images={item.images}
                                onClick={()=>{
                                    setSelectedAlbum(item.albumId)
                                    fetchAlbum(item.albumId)
                                }}
                                />
                            </Col>
                            )}
                            {}
                        </Row>
                        { lastLength >= size ?
                        <div style={{ textAlign: 'center' }}>
                            <Button onClick={()=>loadMore()}>
                                {lang.load_more}
                            </Button>
                        </div>
                        : null
                        }
                    </div>
                    {/* <Pagination className="pagination">
                        <Pagination.Prev 
                        disabled={page === 1 ? true:false}
                        onClick={()=>prevPage()}
                        />
                        <Pagination.Item disabled>
                            {page}
                        </Pagination.Item>
                        <Pagination.Next
                        disabled={galleryList.length < size ? true:false}
                        onClick={()=>nextPage()}
                        />
                    </Pagination> */}
                </div>
                :
                <div>
                    <div className="select-header">
                        <div className="select-title">
                            <div className="back-btn"
                            onClick={()=>{
                                clearData()
                            }}>
                                <FontAwesomeIcon icon={faArrowLeft}/>
                            </div>
                            <div className="header-title">
                                {selectedTitle}
                            </div>
                        </div>
                        { isLoading ?
                        <div>
                            <Spinner
                            variant="primary"
                            animation="border"
                            />
                        </div>
                        : null
                        }
                    </div>
                    <Form 
                    className="form-file"
                    onSubmit={(e)=>{
                        e.preventDefault()
                        uploadImage()
                    }}
                    >
                        <Form.File 
                        accept="image/*"
                        required
                        onChange={(e)=>{
                            let toUpload = e.target.files[0]
                            setToUpload(toUpload)
                        }}/>
                        <Button 
                        type="submit"
                        style={{width: 100, height: "100%"}}
                        size="sm"
                        >
                            {lang.upload}
                        </Button>
                    </Form>
                    <div className="image-container">
                        
                        { selectedImage.length !== 0 ?
                        <Row>
                            { selectedImage.map((item, key)=>
                            <Col key={key} xs={3}>
                                <ImageItem
                                image={item.imagePath}
                                isSelected={
                                    (choseImage.imageId === item.imageId) || 
                                    (choseImages.find(el => el.imageId === item.imageId))
                                }
                                onClick={()=>selectImage(item.imageId, item.imagePath)}
                                />
                            </Col>
                            )}
                        </Row>:
                        <div style={{textAlign: "center", color: "gray", padding: 30}}>
                            <FontAwesomeIcon 
                            icon={faImages}
                            style={{fontSize: 40}}
                            />
                            <div>{lang.no_image}</div>
                        </div>
                        }
                    </div>
                </div>
                }
            </Modal.Body>
            { selectedAlbum !== null ?
            <Modal.Footer>
                <Button 
                disabled={checkDisabledButton()}
                onClick={()=>submitImage()}>
                    {lang.choose_this_image}
                </Button>
                <Button 
                variant="secondary" 
                onClick={props.onHide}>
                    {lang.cancel}
                </Button>
            </Modal.Footer>
            : null
            }
        </Modal>
    )
}

function AlbumItem(props){
    const images = props.images || []
    const lastImagePath = images[images.length - 1]?.imagePath
    const fullLastImagePath = baseURL + lastImagePath

    return(
        <div 
        className="album-item"
        onClick={props.onClick}
        >
            <div className="preview-image">
                { lastImagePath !== undefined ?
                <img src={fullLastImagePath}/>
                : 
                <FontAwesomeIcon icon={faImages}/>
                }
            </div>
            <div className="content">
                {props.title}
            </div>
            
        </div>
    )
}

function ImageItem(props){
    const fullPath = baseURL + props.image
    return(
        <div className="select-image-item"
        onClick={props.onClick}>
            <img src={fullPath}/>
            <div className="img-checkbox"
            style={{
                backgroundColor: props.isSelected ? "#0275d8": "rgba(255, 255, 255, 0.7)",
                color: props.isSelected ? "white": "black"
            }}
            >
                { props.isSelected ?
                    <FontAwesomeIcon icon={faCheck}/>
                    : null
                }
            </div>
        </div>
    )
}

export default ImageModal